
<div class="v-menu-container">
	<div v-if="$slots['header']" class="v-menu-header">
		<slot name="header" />
	</div>
	<slot />
</div>
